module.exports = __webpack_public_path__ + "media/device_images/macbook-roster-profile-89771910.svg";